<template>
  <div
    v-show="emojiPageStatus"
    class="emoji--modal"
    :class="{
      open: emojiPageStatus
    }"
  >
    <button class="emoji--modal--button" @click="disableEmojiPage" />

    <div class="octadesk-emoji-picker--content">
      <EmojiPicker @select="handleEmojiSelection"></EmojiPicker>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  const EmojiPicker = async () => {
    const Picker = await import(
      /* webpackChunkName: "emojipicker" */ '@/app/shared-components/EmojiPicker'
    )
    return Picker
  }

  export default {
    components: {
      EmojiPicker
    },
    computed: {
      ...mapGetters(['emojiPageStatus'])
    },
    mounted() {
      this.preLoadEmojiSprite()
    },
    methods: {
      ...mapActions(['appendTextToComment', 'disableEmojiPage']),
      handleEmojiSelection(emoji) {
        this.appendTextToComment(emoji ? emoji.native + ' ' : '')

        this.disableEmojiPage()

        this.$emit('finishSelection')
      },
      preLoadEmojiSprite() {
        const emojiSpriteImage = new Image()

        emojiSpriteImage.src =
          'https://unpkg.com/emoji-datasource-apple@4.0.4/img/apple/sheets-256/64.png'
      }
    }
  }
</script>

<style lang="scss">
  .emoji--modal {
    position: absolute;
    bottom: 50px;
    left: 27px;
    right: 34px;
    padding: 1rem;
    height: 288px;
    border-radius: 1rem;
    background: #fff;
    z-index: 5;
    opacity: 0;
    pointer-events: none;
    transition: opacity 200ms;
  }

  .emoji-mart-category-label {
    color: #818a96;
    font-size: 0.75rem;
  }

  .emoji--modal.open {
    opacity: 1;
    pointer-events: initial;
  }

  .emoji--modal--button {
    position: absolute;
    right: 1rem;
    top: -1.6rem;
    width: 17px;
    height: 17px;
    cursor: pointer;
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 9px;
      width: 100%;
      height: 2px;
      background: #ccc;
    }
    &:before {
      left: 0px;
      transform: rotate(-45deg);
    }
    &:after {
      right: 0px;
      transform: rotate(45deg);
    }
  }

  .emoji-mart {
    font-size: 14px;
    border: none;
  }

  .emoji-mart .scroller {
    padding: 0;
  }

  .emoji-mart-anchor {
    padding: 6px 4px;
  }

  .emoji-mart-search {
    padding: 0;
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .emoji-mart-search input {
    border-radius: 2px;
    font-size: 14px;
    padding: 0.75rem 1rem;
    background-color: #f2f3f4;
    border: none;
    font-size: 0.75rem;
  }

  .emoji-mart-search input::placeholder {
    color: #b2b9c4;
  }

  .octadesk-emoji-picker--content {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
